// FUNCTION TO CONTROL HEADER/FOOTER FIXED
export function showPartialsFixed(partial, partialShow, partialHide) {
  const partialSelected = document.querySelectorAll(partial);

  partialSelected.forEach((partial) => {

    if (window.innerWidth >= 992) {
      if (window.scrollY > 120) {
        partial.classList.add(partialShow);
        partial.classList.remove(partialHide);

      } else {
        if (partial.classList.contains(partialShow)) {
          partial.classList.add(partialHide);
          partial.classList.remove(partialShow);
        }
      }
    } else {
      if (window.scrollY > 150) {
        partial.classList.add(partialShow);
        partial.classList.remove(partialHide);

      } else {

        if (partial.classList.contains(partialShow)) {
          partial.classList.add(partialHide);
          partial.classList.remove(partialShow);
        }
      }
    }
  });
}
